import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { BullGlyph, TargetReticle } from './BullGlyph';
import { createCursorEngine } from './cursorEngine';
import './bullTarget.css';

export const BullTargetCursor = () => {
  const ref = useRef(null);
  useEffect(() => {
    const host = ref.current;
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let engine = null;
    const sync = () => {
      engine?.destroy(); engine = null;
      const enabled = fine.matches && navigator.maxTouchPoints === 0 && Boolean(window.PointerEvent);
      host.dataset.enabled = String(enabled);
      host.dataset.reducedMotion = String(reduced.matches);
      if (enabled) {
        try { engine = createCursorEngine(host, reduced.matches); }
        catch { host.dataset.enabled = 'false'; document.documentElement.removeAttribute('data-bull-target'); }
      }
    };
    sync();
    fine.addEventListener('change', sync);
    reduced.addEventListener('change', sync);
    return () => {
      fine.removeEventListener('change', sync);
      reduced.removeEventListener('change', sync);
      engine?.destroy();
      document.documentElement.removeAttribute('data-bull-target');
    };
  }, []);

  return createPortal(
    <div ref={ref} className="bt-layer" data-bull-target-layer="" data-enabled="false" data-visible="false" data-hover="false" data-pulsing="false" data-testid="bull-target-cursor" aria-hidden="true">
      {[0, 1, 2].map((index) => (
        <div key={index} className="bt-ghost" data-cursor-ghost="" data-testid={`bull-target-ghost-${index}`}>
          <BullGlyph testId={`bull-target-ghost-glyph-${index}`} />
        </div>
      ))}
      <div className="bt-cursor" data-cursor-main="" data-testid="bull-target-position">
        <svg className="bt-pulse" data-cursor-pulse="" viewBox="0 0 64 64" aria-hidden="true" focusable="false" data-testid="bull-target-pulse">
          <circle cx="32" cy="32" r="30.5" fill="none" stroke="#04110A" strokeWidth="2.6" />
          <circle cx="32" cy="32" r="30.5" fill="none" stroke="currentColor" strokeWidth=".85" />
        </svg>
        <TargetReticle />
        <span className="bt-flash" data-cursor-flash="" data-testid="bull-target-flash" />
        <span className="bt-head" data-testid="bull-target-head"><BullGlyph testId="bull-target-glyph" /></span>
      </div>
    </div>, document.body,
  );
};